// extracted by mini-css-extract-plugin
module.exports = {"container":"LineItemView_container_27szD","title":"LineItemView_title_3PWx_"};